import {Box, Button, Flex, HStack, Link as ChakraLink, Spacer} from '@chakra-ui/react';
import React from 'react';
import {Link} from 'react-router-dom';
import {useAuth, UserStatus} from '../../../auth/AuthProvider';

const Navbar: React.FC = () => {
    const { outUser, isLeader: isLeader, userStatus: userStatus } = useAuth();

    const handleLogout = () => {
        outUser();
    };

    return (
        <Flex
            as="nav"
            position="fixed"
            top="0"
            left="0"
            width="100vw"
            height="80px"
            zIndex="10"
            bg="white"
            opacity="0.95"
            color="brand.500"
            borderBottomWidth="1px"
            borderBottomColor="grey.200"
            px="8"
            py="5"
            alignItems="center"
        >
            <HStack 
                spacing='55'
            >
                <ChakraLink as={Link} to="/home"
                    color="brand.500" 
                    fontWeight="bold"
                    _hover={{ 
                        textDecoration: "none",
                        color: "brand.700"
                    }}
                >
                    Strona główna
                </ChakraLink>
                { userStatus == UserStatus.LoggedIn &&
                    <ChakraLink as={Link} to="/personal-profile"
                                color="brand.500"
                                fontWeight="bold"
                                _hover={{
                                    textDecoration: "none",
                                    color: "brand.700"
                                }}
                    >
                        Dane osobowe
                    </ChakraLink>}
                { userStatus == UserStatus.LoggedIn &&
                <ChakraLink as={Link} to="/scout-profile"
                    color="brand.500" 
                    fontWeight="bold"
                    _hover={{ 
                        textDecoration: "none",
                        color: "brand.700"
                    }}
                >
                    Dane harcerskie
                </ChakraLink>}
                { userStatus == UserStatus.LoggedIn &&
                    <ChakraLink as={Link} to="/scout-census"
                    px="5"
                    py="2"
                    rounded="md"
                    color="white"
                    bg="green.500"
                    fontWeight="bold"
                    _hover={{ 
                        textDecoration: "none",
                        bg: "brand.700"
                    }}
                >
                    Spisz się
                </ChakraLink>}
                { isLeader && (
                    <ChakraLink as={Link} to="/censuses"
                                px="5"
                                py="2"
                                rounded="md"
                                color="white"
                                bg="blue.500"
                                fontWeight="bold"
                                _hover={{
                                    textDecoration: "none",
                                    bg: "blue.700"
                                }}
                    >
                        Spisy
                    </ChakraLink>
                )}
            </HStack>
            <Spacer />
            <Box>
                <ChakraLink
                    as={Button}
                    color="brand.500"
                    fontWeight="bold"
                    type="button"
                    bg="white"
                    _hover={{ 
                        textDecoration: "none",
                        bg: "white",
                        color: "brand.700"
                    }}
                    onClick={handleLogout}
                >
                    Wyloguj
                </ChakraLink>
            </Box>
        </Flex>
    );
};

export default Navbar;